// Authenticated fetch for the whole app.
//
// Granullo's backend is deny-by-default (audit finding P0-5): every /api route
// requires a session unless it is on the explicit public allowlist. Most of the
// app calls the backend through `lib/api.js`, which already attaches the bearer
// token, but a large number of screens use raw `fetch`. Rather than editing
// hundreds of call sites — and inevitably missing some — the token is attached
// centrally here for requests aimed at our own backend.
//
// This makes the frontend authenticate properly. It is not a way to keep
// insecure routes reachable.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function installAuthenticatedFetch() {
  if (typeof window === 'undefined' || window.__granulloFetchPatched) return;
  const original = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    let url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (_) {
      url = '';
    }

    const ourBackend =
      url.startsWith('/api') ||
      (BACKEND && url.startsWith(`${BACKEND}/api`));
    if (!ourBackend) return original(input, init);

    const token = localStorage.getItem('granullo_token');
    if (!token) return original(input, { credentials: 'include', ...init });

    const headers = new Headers(init.headers || {});
    if (!headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return original(input, { credentials: 'include', ...init, headers });
  };

  window.__granulloFetchPatched = true;
}
